module.exports = __webpack_public_path__ + "img/main_bg.4d1b76a5.jpg";